import FilterContainer from './FilterContainer';

export default FilterContainer;
